import { ToolRegistry } from './types';

import searchAssets, { executeSearchAssets } from './data-catalog/search-asset';
import getAssetByUrn, { executeGetAssetByUrn } from './data-catalog/get-asset-by-urn';
import searchIncidents, { executeSearchIncidents } from './incidents/search-incidents';
import getIncidentByIssueNumber, { executeGetIncidentByIssueNumber } from './incidents/get-incident-by-issue-number';
import getIncidentScopeByIssueNumber, { executeGetIncidentScopeByIssueNumber } from './incidents/get-incident-scope';
import getLineageUpstream, { executeGetLineageUpstream } from './lineage/get-lineage-upstream';
import getLineageDownstream, { executeGetLineageDownstream } from './lineage/get-lineage-downstream';
import searchMonitors, { executeSearchMonitors } from './monitors/search-monitors';
import getMonitorById, { executeGetMonitorById } from './monitors/get-monitor-by-id';
import getMonitorRuns, { executeGetMonitorRuns } from './monitors/get-monitor-runs';
import getUserDomains, { executeGetUserDomains } from './user/get-user-domains';
import getCurrentDate, { executeGetCurrentDate } from './user/get-current-date';
import searchTerms, { executeSearchTerms } from './glossary/search-terms';
import searchDataProducts, { executeSearchDataProducts } from './data-products/search-data-products';
import getDataProductById, { executeGetDataProductById } from './data-products/get-data-product-by-id';
import searchDocumentation, { executeSearchDocumentation } from './documentation/search-documentation';

/**
 * Registry of all available tools
 * Note: Only read-only/search tools are included. Modification tools (PATCH, PUT, POST for updates) are excluded.
 */
const tools: ToolRegistry = {
  search_assets: searchAssets,
  get_asset_by_urn: getAssetByUrn,
  search_incidents: searchIncidents,
  get_incident_by_issue_number: getIncidentByIssueNumber,
  get_incident_scope_by_issue_number: getIncidentScopeByIssueNumber,
  get_lineage_upstream: getLineageUpstream,
  get_lineage_downstream: getLineageDownstream,
  search_monitors: searchMonitors,
  get_monitor_by_id: getMonitorById,
  get_monitor_runs: getMonitorRuns,
  get_user_domains: getUserDomains,
  get_current_date: getCurrentDate,
  search_terms: searchTerms,
  search_data_products: searchDataProducts,
  get_data_product_by_id: getDataProductById,
  search_documentation: searchDocumentation,
};

/**
 * Registry of all execute functions
 */
const executors = {
  search_assets: executeSearchAssets,
  get_asset_by_urn: executeGetAssetByUrn,
  search_incidents: executeSearchIncidents,
  get_incident_by_issue_number: executeGetIncidentByIssueNumber,
  get_incident_scope_by_issue_number: executeGetIncidentScopeByIssueNumber,
  get_lineage_upstream: executeGetLineageUpstream,
  get_lineage_downstream: executeGetLineageDownstream,
  search_monitors: executeSearchMonitors,
  get_monitor_by_id: executeGetMonitorById,
  get_monitor_runs: executeGetMonitorRuns,
  get_user_domains: executeGetUserDomains,
  get_current_date: executeGetCurrentDate,
  search_terms: executeSearchTerms,
  search_data_products: executeSearchDataProducts,
  get_data_product_by_id: executeGetDataProductById,
  search_documentation: executeSearchDocumentation,
};

export { tools, executors };
export default tools;
